<div class="displayoptions-main-container">
    <div class="selection-summary">
        <div *ngFor="let option of optionalSummaryList">
            <span class="display-summary"
                ><b>{{ option.title }}:&nbsp;</b>{{ option.value }}
            </span>
        </div>
        <div *ngFor="let option of displayOptionsDdlItems" class="selection-summary">
            <span
                *ngIf="
                    !hideDateRangeDates &&
                    option.isUsedForGetDateRange &&
                    datesToDisplay &&
                    datesToDisplay.length > 0
                "
                class="selection-summary"
            >
                <span *ngFor="let dates of datesToDisplay">
                    <span class="display-summary">
                        <b>{{ dates.dateName }}:</b>
                        {{ dates.dateValueFrom | date: 'MM/dd/yyyy':'UTC' }}
                        <b>-&nbsp;</b>{{ dates.dateValueTo | date: 'MM/dd/yyyy':'UTC' }}
                    </span>
                </span>
            </span>
            <span
                class="display-summary"
                *ngIf="
                    option.isSelectSummaryShow && option.filteredValue != '' && !option.hideDisplay
                "
            >
                <b>{{ option.summarySectionTitleName }}:&nbsp;</b>{{ option.filteredValue }}
            </span>
        </div>
    </div>
    <div class="displayoptions-edit-button" *ngIf="showEditButton">
        <span
            id="edit-button"
            mat-button
            (click)="isDisplayFilterDialogOpen = !isDisplayFilterDialogOpen; clickEditButton()"
        >
            Edit
        </span>
        <div class="display-filter-option-container">
            <div class="display-filter-option-area" *ngIf="isDisplayFilterDialogOpen">
                <mat-card class="filter-option-card">
                    <div id="displayOptions-dialog-surface" class="display-opt-filter-container">
                        <div id="daterange-filter-title" class="filter-title">Display Options</div>
                        <div>
                            <div *ngFor="let ddl of displayOptionsDdlItems">
                                <div
                                    *ngIf="!ddl.hideDdlController && !ddl.hideFilterItem"
                                    id="view-by-title"
                                    class="sub-filter-title"
                                >
                                    {{ ddl.filterName }}
                                </div>
                                <div
                                    *ngIf="!ddl.hideDdlController && !ddl.hideFilterItem"
                                    id="sub-filter-{{ ddl.optionKey }}"
                                    class="filter-ddl"
                                >
                                    <div class="date-range-option-area" *ngIf="ddl.isUsedForGetDateRange && datePickerValues.allowCustomDateRange">
                                        <div class="date-range-option-title-area row-layout-track">
                                            <div
                                                    [ngStyle]="{ backgroundColor: !ddl.showCustomDateRange ? 'lightgrey': ''}"
                                                    (click)="showCustomDateRangeSelection('standard', ddl)"
                                                    class="date-range-option-title largecard-layout-box__50"
                                            >Standard
                                            </div>
                                            <div
                                                    [ngStyle]="{ backgroundColor: ddl.showCustomDateRange ? 'lightgrey': ''}"
                                                    (click)="showCustomDateRangeSelection('custom', ddl)"
                                                    class="date-range-option-title largecard-layout-box__50"
                                            >Custom
                                            </div>                                    
                                        </div>
                                        
                                        <div class="display-options-date-picker-area" *ngIf="ddl.showCustomDateRange">
                                            <div class="display-options-date-picker-items" (click)="picker.open()"> 
                                               <span class="date-picker-toggle">
                                                    <mat-icon class="date-picker-icon far fa-calendar-day"></mat-icon></span>           
                                                <span class="date-picker-text">Select Date Range </span>
                                                <span title="Please select a date within one year from the start date">
                                                    <mat-icon class="date-info-icon far fa-info-circle"></mat-icon></span>
                                                <mat-date-range-input [rangePicker]="picker" class="date-range-input-container">  
<!--                                                    TODO: Add date validation-->
                                                        <input
                                                                [value]="datePickerValues.startDate"
                                                                class="date-input"
                                                                matStartDate
                                                                placeholder="Start date"
                                                                [min]="datePickerValues.minDate"
                                                                [disabled]="true"
                                                                (dateChange)="onCustomDateRangeChange($event, 'startDate')"                                                                
                                                        >                     
                                                        <input
                                                                [value]="datePickerValues.endDate"
                                                                class="date-input"
                                                                matEndDate
                                                                placeholder="End date"
                                                                [disabled]="true"
                                                                (dateChange)="onCustomDateRangeChange($event, 'endDate')"                                                                
                                                        > 
                                                </mat-date-range-input>
                                                <mat-date-range-picker
                                                    #picker
                                                    (closed)="datePickerStatus(false)"
                                                    (opened)="datePickerStatus(true)"
                                                    [startAt]="datePickerValues.startDate"
                                                    [disabled]="false"                                                    
                                                ></mat-date-range-picker>
                                            </div>
                                               <div>
                                                   <span class="date-range-error-message" *ngIf="!this.datePickerValues.isDateRangeValid">
                                                       {{ this.datePickerValues.dateRangeErrorMessage }}
                                                   </span>
                                               </div>  
                                        </div>
                                    </div>
                                    <angular2-multiselect
                                        *ngIf="!ddl.showCustomDateRange"
                                        [data]="ddl.filterItems.filterItems"
                                        [(ngModel)]="ddl.filterItems.selectedItems"
                                        [settings]="ddl.filterItems.settings"
                                        (onSelect)="onItemSelect($event)"
                                        (onDeSelect)="onItemDeSelect($event)"
                                        (onSelectAll)="onSelectAll($event)"
                                        (onDeSelectAll)="onDeSelectAll($event)"
                                        (onOpen)="
                                            setContainerHeight(
                                                'sub-filter-' + ddl.optionKey,
                                                true,
                                                ddl.filterItems.filterItems !== null
                                                    ? ddl.filterItems.filterItems.length
                                                    : 0,
                                                ddl.filterItems.settings.enableSearchFilter
                                            )
                                        "
                                        (onClose)="
                                            setContainerHeight(
                                                'sub-filter-' + ddl.optionKey,
                                                false,
                                                0
                                            )
                                        "
                                        (onScrollToEnd)="fetchMore($event, ddl)"
                                        [loading]="loading"
                                    >
                                    </angular2-multiselect>
                                </div>
                            </div>
                        </div>
                        <div class="button-sets" id="apply-cancel-buttons">
                            <button
                                mat-button
                                outlined
                                class=""
                                id="daterange-cancel-button"
                                (click)="isDisplayFilterDialogOpen = !isDisplayFilterDialogOpen"
                            >
                                CANCEL
                            </button>
                            <button
                                mat-button
                                class="apply-button"
                                id="daterange-apply-button"
                                [disabled]="isDateRangeApplyBtnDisabled"
                                (click)="
                                    emitDisplayOptions();
                                    isDisplayFilterDialogOpen = !isDisplayFilterDialogOpen
                                "
                            >
                                APPLY
                            </button>
                        </div>
                    </div>
                </mat-card>
            </div>
        </div>
    </div>
</div>
